import React from "react"
import PropTypes from "prop-types"
import "./menu.scss"

const Menu = ({ steps, currentPageNumber }) => {
  const currentStep = steps.find(
    ({ pageNumber }) => pageNumber === currentPageNumber
  )

  // If we're on a noMenu page, don't render a thing
  if (currentStep.noMenu) {
    return null
  }

  return (
    <div className="menu">
      <div className="pageBanner">
        <div className="description">
          <div className="storeLogo" />{" "}
          <div className="storeTitle">
            {currentStep.text}
            {currentStep.appendStoreName}
          </div>
        </div>
      </div>
      {/* {currentStep.showDevice && <Device />} */}
    </div>
  )
}

Menu.propTypes = {
  steps: PropTypes.array.isRequired,
  currentPageNumber: PropTypes.number.isRequired
}

export default Menu
